import type * as models from 'pkg/api/models';
import type { Country } from 'pkg/api/models/country';
import type { SportType } from 'pkg/api/models/sport';

export type AccountRole = 'staff' | 'parent' | 'player';

export enum AccountLoginMethod {
	Email = 'email',
	Apple = 'apple',
}

export interface Account {
	id?: number;
	role?: AccountRole;
	firstName?: string;
	lastName?: string;
	countryCode?: string;
	loginType?: AccountLoginMethod;
	email?: string;
	password?: string;
	profileImage?: string;

	year?: number;
	month?: number;
	day?: number;

	createChildAccount?: boolean;
	appleAuthCode?: string;
	inviteKey?: string;
	ssoToken?: string;
}

export interface Group {
	groupName: string;
	organizationName: string;
	isOrganization?: boolean;
	profileImageUrl: string;
	primaryColor: string;
	country: Country;
	organizationId: number;
	organizationSlug?: string;
	allowPlayerSignup?: boolean;
	sportType?: SportType;
}

export interface Invite extends Group {
	inviteId: number;
	author: any;
	targetChildren: any;
	targetGroups: any;
	targetUsers: any;
	targetGroupRoles: models.membership.RoleType[];
}

export interface OnboardingInfo {
	invite?: Invite;
	group?: Group;
	account?: Account;
	targetAccount?: Account;
	identityProviders?: models.identityProvider.ScrubbedIdentityProvider[];
}
